


















import { Component, Prop, Vue } from "vue-property-decorator";
import { DefaBaseButton } from "@defa-as/components";
import { formModule } from "@/store/modules/form";
import SectionLabel from "@/components/sections/section-parts/SectionLabel.vue";

@Component({
  components: {
    SectionLabel,
    DefaBaseButton,
  },
})
export default class SectionInfo extends Vue {
  @Prop({ required: true }) readonly label!: string;
  @Prop({ required: true }) readonly bodyItems!: string[];
  @Prop({ required: true }) readonly progressionText!: string;

  get formModule() {
    return formModule;
  }
}
